import { CatExpertRouterLink } from "../../../app-routing-enum";

export const dashboardTypes = [
  {
    label: "Country View",
    value: "country_view",
  },
  {
    label: "Store view",
    value: "store_view",
  },
];

export const DASHBOARD_TYPES = dashboardTypes.map((item: any) => item.value);

export const DASHBOARD_CARDS = [
  {
    name: "Country View",
    description: "View and analyze data by country",
    icon: "country-view",
    route: CatExpertRouterLink.DashboardCountryView,
    buttonText: "Country View",
    show: false,
  },
  {
    name: "Store view",
    description: "Coming soon",
    icon: "store-view",
    route: "",
    buttonText: "Store View",
    show: true,
  },
  {
    name: "Target Setting",
    description: "Coming soon",
    icon: "target-setting",
    route: "",
    buttonText: "Target Setting",
    show: true,
  },
  {
    name: "Report generation",
    description: "Coming soon",
    icon: "report-generation",
    route: "",
    buttonText: "Report generation",
    show: true,
  },
];

export const DASHBOARD_SUMMARY = {
  heading: "Dashboard",
  tableColumns: [
    {
      label: "Name",
      value: "name",
      valueType: "",
      filterType: "input_text",
      sortable: true,
      hasEdit: false,
    },
    {
      label: "Type",
      value: "type",
      valueType: "",
      filterType: "dropdown",
      filterOptions: dashboardTypes,
      selectedFilterValues: [],
      sortable: true,
    },
    {
      label: "Experiments Linked",
      value: "assets_linked",
      valueType: "",
      filterType: "",
      sortable: true,
    },
    {
      label: "Created At",
      value: "created_at",
      valueType: "",
      filterType: "",
      sortable: true,
    },
    {
      label: "Action",
      value: "action",
      valueType: "icon-view",
      filterType: "",
      sortable: false,
      actionList: [
        {
          label: "View",
          key: "view",
          icon: "icon-view-eye",
          color: "#666666",
          callBack: "navigateToDashboard",
          padding: "6px",
        },
        {
          label: "Share",
          key: "share",
          icon: "share-icon",
          color: "#666666",
          callBack: "shareDashboardLink",
          padding: "6px",
          disabledKey: "access_type",
          disabledValue: "['read', 'edit']",
        },
        {
          label: "Delete",
          key: "delete",
          icon: "icon-delete",
          color: "#DC3545",
          callBack: "deleteDashboard",
          padding: "6px",
          disabledKey: "access_type",
          disabledValue: "['read', 'edit']",
        },
      ],
    },
  ],
};

export const confirmDialogContent = {
  head: "Delete Dashboard",
  description: "Are you sure want to delete",
  btnCancel: "Cancel",
  btnProceed: "Delete",
  showConfirmDialog: false,
  styleClass: "confirm-dialog",
  dialogkey: "delete",
};

export const tabDetails = [
  {
    heading: "My Dashboard",
    key: "owned",
  },
  {
    heading: "Shared Dashboard",
    key: "shared",
  },
];
